<template>
    <div>
        <top_box></top_box>
        <div class="main_box">
            <div class="">
				<!-- 搜索框 -->
                <div class="search">
                    <div class="inpunt_box">
                        <el-input @change="confirm" :placeholder="$t('m.MallCenter_06')" v-model="value">
                            <i slot="prefix" style="display: flex;align-items: center;">
                                <img class="header-icon" style="width:16px;height:16px" src="@/static/images/sousuoicon.png" alt="" />
                            </i>
                            <template slot="append">
                                <div class="search_btn" @click="confirm">{{ $t('m.home_01') }}</div>
                            </template>
                        </el-input>
                    </div>
                </div>
				<!-- 导航 -->
                <div class="breadcrumb">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">{{$t('m.MallCenter_25')}}</el-breadcrumb-item>
                        <el-breadcrumb-item>{{$t('m.MallCenter_26')}}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <!-- 一级分类 -->
                <div class="classification firstcat">
                    <div class="title">{{ $t('m.MallCenter_02') }}：</div>
                    <div class="item-box" :style="cat1_open_idx?cat1_open_idx_txt:''">
                    <!-- <div class="item-box"  style="height: auto!important;"> -->
                        <div class="item pointer" :class="{ Selected_style: item.Selected }"
                            v-for="(item, index) in goods_cat_list" :key="index" @click="chang_cat(index)">
                            {{ item.name }}
                        </div>
                    </div>
					<div class="jt" @click="cat1_open">
						<img :style="cat1_open_idx?'transform: rotate(180deg);transition: 0.3s;':''" src="../static/jiantouxia.png" alt="">
					</div>
                </div>
				<div class="classification firstcat" v-if="goods_cat_list[Selected_idx].son.length>1">
				    <div class="title" style="opacity: 0;">{{ $t('m.MallCenter_02') }}：</div>
				    <!-- <div class="item-box" :style="cat1_open_idx?cat1_open_idx_txt:''"> -->
				    <div class="item-box" v-if="item.id!=0" style="height: auto!important;">
				        <div class="item pointer" :class="{ Selected_style: item.Selected }"
				            v-for="(item, index) in goods_cat_list[Selected_idx].son" :key="index" @click="chang_cat1(index)">
				            {{ item.name }}
				        </div>
				    </div>
				</div>
				<div class="classification firstcat" v-if="goods_cat_list[Selected_idx].son[Selected_idx1].son.length>1">
				    <div class="title" style="opacity: 0;">{{ $t('m.MallCenter_02') }}：</div>
				    <!-- <div class="item-box" :style="cat1_open_idx?cat1_open_idx_txt:''"> -->
				    <div class="item-box" style="height: auto!important;">
				        <div class="item pointer" v-if="item.id!=0" :class="{ Selected_style: item.Selected }"
				            v-for="(item, index) in goods_cat_list[Selected_idx].son[Selected_idx1].son" :key="index" @click="chang_cat2(index)">
				            {{ item.name }}
				        </div>
				    </div>
				</div>
				<!-- 二级分类 -->
                <div class="classification">
                    <div class="title">{{ $t('m.MallCenter_03') }}：</div>
                    <div class="item-box" :style="cat2_open_idx?cat2_open_idx_txt:''">
                        <div class="item pointer" :class="{ Selected_style: item.Selected }"
                            v-for="(item, index) in goods_brand_list" :key="index" @click="chang_brand(index)">
                            {{ item.name }}
                        </div>
                    </div>
					<div class="jt" @click="cat2_open">
						<img :style="cat2_open_idx?'transform: rotate(180deg);transition: 0.3s;':''" src="../static/jiantouxia.png" alt="">
					</div>
                </div>
				<!-- 数据列表 pc -->
                <div class="tableDatabox">
                    <div class="tablemain">
                        <el-table :data="tableData" border :expand-row-keys="expands" row-key="id">
							<!-- 暂无数据 -->
							<template slot="empty">
								<el-empty :image-size="100" :description="$t('m.new_txt3')"></el-empty>
							</template>
							<!-- 展开框 -->
                            <el-table-column type="expand" width="0">
                                <template slot-scope="props">
                                    <el-form label-position="left" inline>
                                        <el-form-item>
                                            <div class="commodity_info" v-for="(item, index) in Object.values(props.row.goods_spec_price)" :key="index">
												<!-- 规格 -->
												<div 
												class="guigename"
												v-if="props.row.goods_spec_name&&index==0"
												>{{props.row.goods_spec_name}}</div>
												<!--选择 -->
                                                <div class="ridio pointer" :class="{ Selected_style: item.Selected }"
                                                    @click="changradio(props.row, index)">
                                                    <img v-if="item.Selected" src="@/static/images/Selected.png" alt="">
                                                    <img v-else src="@/static/images/notSelected.png" alt="">
                                                </div>
												<!-- 规格名 -->
                                                <div class="text">
                                                    {{ item.name }}
                                                </div>
											<!-- 人民币 -->
											<div class="text1" v-if="$t('m.is_en')=='false'">
											    单价(人民币)：{{ item.price_rmb_show }}
											</div>
											<!-- 美元 -->
											<div class="text1" v-if="$t('m.is_en')=='true'">
											    Unit Price (USD)：{{ item.price_dollar_show }}
											</div>
												<!-- 数量 -->
                                                <div class="InputNumber">
                                                    <div class="pointer btnbox flex f-ct f-btc" @click="reduce(index, props.row)">
														<span>－</span>
													</div>
                                                    <div class="inpunumber">
                                                        <el-input v-model="item.num" @input="aaaipt($event,index, props.row,item)"></el-input>
                                                    </div>
                                                    <div class="pointer btnbox flex f-ct f-btc" @click="add(index, props.row)">
														<span>＋</span>
													</div>
                                                </div>
                                            </div>
                                        </el-form-item>
                                    </el-form>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="0" label="" type="index"></el-table-column>
                            <el-table-column min-width="130" :label="$t('m.MallCenter_08')" prop="thumb">
                                <template slot-scope="scope">
                                    <el-image class="pointer" style="width: 50px; height: 50px" :src="scope.row.thumb"
                                        :preview-src-list="[scope.row.thumb]">
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="150" :label="$t('m.MallCenter_09')" prop="name">
                                <template slot-scope="scope">
                                    <div class="red_style pointer" @click="see_info(scope.row.id)">
                                        {{ scope.row.name }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="140" :label="$t('m.MallCenter_10')" prop="cat.name"></el-table-column>
                            <el-table-column min-width="90" :label="$t('m.MallCenter_11')" prop="brand.name"></el-table-column>
                            <el-table-column min-width="90" :label="$t('m.MallCenter_12')" prop="model"></el-table-column>
                            <!-- <el-table-column min-width="130" v-if="$t('m.is_en')=='false'" :label="$t('m.MallCenter_13')" prop="price_rmb_show"></el-table-column> -->
                            <!-- <el-table-column min-width="130" v-if="$t('m.is_en')=='true'" :label="$t('m.MallCenter_14')" prop="price_dollar_show"></el-table-column> -->
                            <el-table-column min-width="130" :label="$t('m.MallCenter_15')" align="center">
                                <template slot-scope="scope">
                                    <div class="pointer" @click="expandRow(scope.row)">
										<div class="pointerbox">
											<span v-if="!scope.row.isopen">{{$t('m.MallCenter_16')}} </span>
											<span v-else>{{$t('m.MallCenter_16')}} </span>
											<i :style="scope.row.isopen?'transform: rotate(180deg);transition: 0.3s;':''" class="el-icon-arrow-down"></i>
										</div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
				<!-- h5的表 -->
				<div class="tableDatabox_h5">
					<!-- 其他信息 -->
					<div class="other_box wow animate__animated animate__fadeInUp" v-for="(item,index) in tableData">
						<p class="tit"></p>
						<div class="item_o">
							<div class="status flex f-ct f-bt">
								<p>-{{$t('m.shoping_txt1')}}</p>
							</div>
							<div class="goods flex">
								<div class="l">
									<!-- <img :src="item.thumb" alt=""> -->
									<el-image class="pointer" :src="item.thumb"
									    :preview-src-list="[item.thumb]">
									</el-image>
								</div>
								<div class="r">
									<div class="tbox1 flex f-ct f-bt">
										<p class="line2" style="cursor: pointer;" @click="see_info(item.id,true)">{{item.name}}</p>
									</div>
									<div class="tbox2 flex f-ct f-bt">
										<p>{{$t('m.MallCenter_11')}}：{{item.brand.name}}</p>
										<p style="opacity: 0;">x1</p>
									</div>
								</div>
							</div>
						</div>
						<div class="item flex f-ct f-bt">
							<p>{{$t('m.MallCenter_10')}}</p>
							<p>{{item.cat.name}}</p>
						</div>
						<div class="item flex f-ct f-bt">
							<p>{{$t('m.MallCenter_12')}}</p>
							<p>{{item.model}}</p>
						</div>
						<div class="item flex f-ct f-bt" v-if="$t('m.is_en')=='false'">
							<p>{{$t('m.MallCenter_13')}}</p>
							<p>￥{{item.price_rmb_show}}</p>
						</div>
						<div class="item flex f-ct f-bt" v-if="$t('m.is_en')=='true'">
							<p>{{$t('m.MallCenter_14')}}</p>
							<p>${{item.price_dollar_show}}</p>
						</div>
						<div class="ggboxc" :style="item.isopen?'height: auto;transition: 0.3s;':''">
							<!-- 规格部分 -->
							<div class="tit2 flex f-ct f-bt" @click="expandRow(item)">
								<p>-{{item.goods_spec_name}}</p>
								<img :style="item.isopen?'transform: rotate(180deg);transition: 0.3s;':''" src="../static/jiantouxia.png" alt="">
							</div>
							<div class="gg_box" v-for="(gg_item,gg_index) in item.goods_spec_price" :key="gg_index">
								<div class="item_gg1 flex f-ct" @click="changradio(item,gg_index)">
									<div :class="gg_item.Selected?'active':''">
										<img v-if="gg_item.Selected" src="@/static/images/Selected.png" alt="">
										<img v-else src="@/static/images/notSelected.png" alt="">
									</div>
									<p>{{gg_item.name}}</p>
								</div>
								<div class="item_gg2 flex f-ct f-bt">
									<div>
										<div class="pointer btnbox flex f-ct f-btc" @click.stop="reduce(gg_index, item)">
											<span>－</span>
										</div>
										<div class="inpunumber">
										    <el-input v-model="gg_item.num" @input="aaaipt($event,gg_index, item,gg_item)"></el-input>
										</div>
										<div class="pointer btnbox flex f-ct f-btc" @click.stop="add(gg_index, item)">
											<span>＋</span>
										</div>
									</div>
									<p>￥{{gg_item.price_rmb_show}}</p>
									<p>${{gg_item.price_dollar_show}}</p>
								</div>
							</div>
						</div>
					</div>	
				</div>
				<!-- 数据列表分页 -->
                <div class="pagingbox">
                    <div class="pages_pc">
                        <el-pagination background layout="prev, pager, next" :current-page="current_page"
                            @current-change="handleCurrentChange" :page-size="page_size" :total="total">
                        </el-pagination>
                    </div>
                    <div class="pagea">
                        {{ $t('m.MallCenter_04') }} {{ total }} {{ $t('m.MallCenter_05') }}
                    </div>
                </div>
				<!-- 数据列表下单按钮 -->
                <div class="pagingbox _btn">
                    <el-button type="danger" @click="PlaceOrder">
						{{ $t('m.MallCenter_18') }}
						<i class="el-icon-arrow-right el-icon--right"></i>
                    </el-button>
                </div>
            </div>
			<!-- 未登录显示提示 -->
           <div v-if="!user_data" class="usertext">
                <p>{{$t('m.new_txt1')}}，<span class="pointer" @click="login">{{$t('m.new_txt2')}}</span></p>
            </div>
        </div>
		
		<!-- 弹出框 -->
		<el-dialog :visible.sync="showbox" width="60%" center>
		    <div class="showbox">
		        <div class="showbox_01">
		            <h1>{{ info_data.name }}</h1>
		            <p><span>{{$t('m.MallCenter_12')}}：{{ info_data.model }}</span> | {{$t('m.MallCenter_11')}}：{{ info_brand.name }} | ￥{{info_data.price_rmb_show}} | ${{info_data.price_dollar_show}} </p>
		        </div>
		        <div class="showbox_02">
		            <div class="show_left">
		
		            </div>
		            <div class="show_main">
						<div class="banner" style="margin-top: 20px;">
							<el-carousel indicator-position="none" :loop="true" height="27rem">
								<el-carousel-item v-for="(item_img,index) in info_imgarr" :key="index">
									<el-image :src="item_img.image" style="width: 100%; height: 27rem" ></el-image>
								</el-carousel-item>
							</el-carousel>
						</div>
		                <p class="info_title">{{$t('m.MallCenter_19')}}</p>
		                <div class="info_box">
		                    <div v-html="info_data.content"></div>
		                </div>
		            </div>
		            <div class="show_right"></div>
		        </div>
		    </div>
		</el-dialog>
		
		<el-dialog :visible.sync="showbox1" width="100%" center>
		    <div class="showbox">
		        <div class="showbox_01">
		            <h1>{{ info_data.name }}</h1>
		            <p><span>{{$t('m.MallCenter_12')}}：{{ info_data.model }}</span> | {{$t('m.MallCenter_11')}}：{{ info_brand.name }} | ￥{{info_data.price_rmb_show}} | ${{info_data.price_dollar_show}} </p>
		        </div>
		        <div class="showbox_02">
		            <div class="show_left">
		
		            </div>
		            <div class="show_main">
						<div class="banner" style="margin-top: 20px;">
							<el-carousel indicator-position="none" :loop="true" height="16.2rem">
								<el-carousel-item v-for="(item_img,index) in info_imgarr" :key="index">
									<el-image :src="item_img.image" style="width: 100%; height: 16.2rem" ></el-image>
								</el-carousel-item>
							</el-carousel>
						</div>
		                <p class="info_title">{{$t('m.MallCenter_19')}}</p>
		                <div class="info_box">
		                    <div v-html="info_data.content"></div>
		                </div>
		            </div>
		            <div class="show_right"></div>
		        </div>
		    </div>
		</el-dialog>
		
		<!-- 公共底部 -->
		<fot_box></fot_box>
    </div>
</template>
<script>

import top_box from '../components/header_top'
import fot_box from '../components/foot'
import encryption from '@/utils/encryption.js'
export default {
    components: {
        top_box,fot_box
    },
    data() {
        return {
            srcList: [
                'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',

            ],
            user_data: {},
            value: '',
            total: 0,   //总条数
            page_size: 10,  //每页显示多少条
            current_page: 1,  //当前页
            tableData: [],
            goods_cat_list: [],  //商品分类
            goods_brand_list: [],  //商品品牌
            brand_id: 0,   //品牌id
            cat_id: 0,      //分类id
            info_data: {},   //商品详情
            info_brand: {}, //商品详情
            showbox: false,
            showbox1: false,
            goods_arr: [],
            expands: [],
			goods_arr_history: [], //下单历史
			tableData_history: [], //分页历史
			info_imgarr:[],
			cat1_open_idx:false,
			cat1_open_idx_txt:'',
			cat2_open_idx:false,
			cat2_open_idx_txt:'',
			// H5版本列表
			is_pages:true,
			Selected_idx:0,
			Selected_idx1:0,
        }
    },
    created() {
		window.addEventListener('scroll', this.Scrollbottom);  //页面加载时监听滚动事件
    },
	destroyed() {
		window.removeEventListener('scroll', this.Scrollbottom) //页面离开后销毁监听事件
	},
    mounted() {
        let user_data = JSON.parse(localStorage.getItem('user_data'))
        this.user_data = user_data
        this.value = this.$router.currentRoute.query.value || ''
        this.brand_id = this.$router.currentRoute.query.id || 0
        this.gat_cat()
        this.get_brand()
        this.getData()
		
		
    },
    methods: {
		aaaipt(e,index, row,ggitem){
			console.log(e)
			if(e>0&&(!ggitem.Selected)){
				this.changradio2(row,index)
			}
			if(e<=0&&ggitem.Selected){
				this.changradio2(row,index)
			}
		},
		// 触底函数
		Scrollbottom() {
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			let clientHeight = document.documentElement.clientHeight;
			let scrollHeight = document.documentElement.scrollHeight;
			if (scrollTop + clientHeight >= scrollHeight) {
				// console.log("滚动到底部了")
				if(localStorage.getItem('user_data')){
					if(this.is_pages){
						this.getData()
					}
				}
			}
		},
		// 分类1 开关
		cat1_open(){
			this.cat1_open_idx = !this.cat1_open_idx
			// 判断显示屏宽
			var is_h5 = document.documentElement.clientWidth || document.body.clientHeight;
			if(is_h5>1200){
				this.cat1_open_idx_txt = 'height: auto;'
			}else{
				this.cat1_open_idx_txt = 'height: 6rem!important;overflow: scroll;'
			}
		},
		// 分类2 开关
		cat2_open(){
			this.cat2_open_idx = !this.cat2_open_idx
			// 判断显示屏宽
			var is_h5 = document.documentElement.clientWidth || document.body.clientHeight;
			if(is_h5>1200){
				this.cat2_open_idx_txt = 'height: auto;'
			}else{
				this.cat2_open_idx_txt = 'height: 6rem!important;overflow: scroll;'
			}
		},
        expandRow(row) {
			// 改变isopen的值
            this.tableData.forEach(item => {
                if (item.id == row.id) {
                    item.isopen = !item.isopen
                }
            })
            if (this.expands.indexOf(row.id) < 0) {
                // this.expands = [];
                this.expands.push(row.id);
            } else {
				var arr = []
				for(var i in this.expands){
					if(this.expands[i]!=row.id){
						arr.push(this.expands[i])
					}
				}
                this.expands = arr;
            }
        },
        //查看商品详情
        see_info(id,is_one) {
            let param = {
                goods_id: id
            }
            let sing = encryption.getSing(param)
            this.$api.goods_details(param, sing).then((res) => {
                if (res.data.code == 1) {
                    this.info_data = res.data.data.info
                    this.info_brand = res.data.data.brand
					this.info_imgarr = res.data.data.img_list
                    if(is_one){
                    	this.showbox1 = true
                    }else{
                    	this.showbox = true
                    }
                }
            })
        },
		
        //品牌选择
        chang_brand(index) {
            if (this.goods_brand_list[index].Selected == true) {
                this.goods_brand_list[index].Selected = false
                this.goods_brand_list[0].Selected = true
                this.brand_id = 0
            } else {
                this.goods_brand_list.forEach(item => {
                    item.Selected = false
                })
                this.goods_brand_list[index].Selected = true
                this.brand_id = this.goods_brand_list[index].id
            }
            this.current_page = 1
            this.getData()
        },
        //分类选择
        chang_cat(index) {
            if (this.goods_cat_list[index].Selected == true) {
                this.goods_cat_list[index].Selected = false
                this.goods_cat_list[0].Selected = true
                this.cat_id = 0
				this.Selected_idx = 0
				this.Selected_idx1 = 0
            } else {
                this.goods_cat_list.forEach(item => {
                    item.Selected = false
                })
                this.goods_cat_list[index].Selected = true
                this.cat_id = this.goods_cat_list[index].id
				
				this.Selected_idx = index
				for(var i in this.goods_cat_list[index].son){
					if(i=='0'){
						this.goods_cat_list[index].son[i].Selected = true
					}else{
						this.goods_cat_list[index].son[i].Selected = false
					}
				}
				
            }
            this.current_page = 1
            this.getData()
        },
		//分类选择
		chang_cat1(index) {
		    if (this.goods_cat_list[this.Selected_idx].son[index].Selected == true) {
		        this.goods_cat_list[this.Selected_idx].son[index].Selected = false
		        this.goods_cat_list[this.Selected_idx].son[0].Selected = true
		        this.cat_id = this.goods_cat_list[this.Selected_idx].id
				this.Selected_idx1 = 0
		    } else {
				for(var i in this.goods_cat_list[this.Selected_idx].son){
					this.goods_cat_list[this.Selected_idx].son[i].Selected = false
				}
				this.goods_cat_list[this.Selected_idx].son[index].Selected = true
				this.cat_id = this.goods_cat_list[this.Selected_idx].son[index].id
		        // this.goods_cat_list.forEach(item => {
		        //     item.Selected = false
		        // })
		        // this.goods_cat_list[index].Selected = true
		        // this.cat_id = this.goods_cat_list[index].id
				if(this.goods_cat_list[this.Selected_idx].son[index].id==0){
					this.cat_id = this.goods_cat_list[this.Selected_idx].id
				}
				this.Selected_idx1 = index
			}
		    this.current_page = 1
		    this.getData()
		},
		//分类选择
		chang_cat2(index) {
			
		    if (this.goods_cat_list[this.Selected_idx].son[this.Selected_idx1].son[index].Selected == true) {
		        this.goods_cat_list[this.Selected_idx].son[this.Selected_idx1].son[index].Selected = false
		        this.goods_cat_list[this.Selected_idx].son[this.Selected_idx1].son[0].Selected = true
				
				if(this.goods_cat_list[this.Selected_idx].son[this.Selected_idx1].id){
					this.cat_id = this.goods_cat_list[this.Selected_idx].son[this.Selected_idx1].id
				}else{
					this.cat_id = this.goods_cat_list[this.Selected_idx].id
				}
		        
				
		    } else {
				for(var i in this.goods_cat_list[this.Selected_idx].son[this.Selected_idx1].son){
					this.goods_cat_list[this.Selected_idx].son[this.Selected_idx1].son[i].Selected = false
				}
				this.goods_cat_list[this.Selected_idx].son[this.Selected_idx1].son[index].Selected = true
				
				if(this.goods_cat_list[this.Selected_idx].son[this.Selected_idx1].son[index].id){
					this.cat_id = this.goods_cat_list[this.Selected_idx].son[this.Selected_idx1].son[index].id
				}else{
					if(this.goods_cat_list[this.Selected_idx].son[this.Selected_idx1].id){
						this.cat_id = this.goods_cat_list[this.Selected_idx].son[this.Selected_idx1].id
					}else{
						this.cat_id = this.goods_cat_list[this.Selected_idx].id
					}
				}
				
			}
		    this.current_page = 1
		    this.getData()
		},
        getData() {
            let user_id = ''
            if (localStorage.getItem('user_data')) {
                user_id = JSON.parse(localStorage.getItem('user_data')).id || ''
            }
			if(this.current_page==1){
				this.is_pages = true
			}
            let param = {
                user_id: user_id,
                brand_id: this.brand_id,
                cat_id: this.cat_id,
                keywords: this.value || '',
                p: this.current_page
            }
            let sing = encryption.getSing(param)
            this.$api.goods_list(param, sing).then((res) => {
                if (res.data.code == 1) {
					for(var i in res.data.data.list){
						this.expands.push(res.data.data.list[i].id)
						res.data.data.list[i].isopen = true
					}
					let tableData
					if(user_id){
						tableData = res.data.data.list || []
					}else{
						tableData = res.data.data.list.splice(0,3)
					}
					
                    this.total = res.data.data.count
                    tableData.forEach(item1 => {
						for(var key in item1.goods_spec){
							item1.goods_spec_name = key
						}
                        let list = Object.values(item1.goods_spec)[0]
                        if (list) {
                            list.forEach(item => {
                                this.$set(item1.goods_spec_price[item.spec_item_id], 'title', '规格顶')
                                this.$set(item1.goods_spec_price[item.spec_item_id], 'name', item.name)
                                this.$set(item1.goods_spec_price[item.spec_item_id], 'num', 0)
                                this.$set(item1.goods_spec_price[item.spec_item_id], 'Selected', false)
                            })
							var arr = []
							for(var i in item1.goods_spec_price){
								arr.push(item1.goods_spec_price[i])
							}
							item1.goods_spec_price = arr
                        }
						
                    })
					// 判断显示屏宽
					var is_h5 = document.documentElement.clientWidth || document.body.clientHeight;
					if(is_h5>1200){
						// PC
						this.tableData = tableData
					}else{
						// H5
						if(tableData.length){
							this.current_page++
							if(this.current_page == 1){
								this.tableData = tableData
							}else{
								this.tableData = this.tableData.concat(tableData)
							}
						}else{
							this.is_pages = false
						}
					}
                }
            })
        },
        //商品分类
        gat_cat() {
			var that = this
            this.$api.gat_cat().then((res) => {
                if (res.data.code == 1) {
                    this.goods_cat_list = res.data.data || []
                    this.goods_cat_list.unshift({
                        id: 0,
                        name: this.$t('m.MallCenter_20'),
						son:[]
                    })
                    this.goods_cat_list.forEach(item => {
                        this.$set(item, 'Selected', false)
                        if (item.id == 0) {
                            item.Selected = true
                            that.Selected_idx = 0
                            that.Selected_idx1 = 0
                        }
                    })
					for(var i in  this.goods_cat_list){
						 this.goods_cat_list[i].son.unshift({
						    id: 0,
						    name: this.$t('m.MallCenter_20'),
						 	Selected:true,
						})
						for(var k in this.goods_cat_list[i].son){
							console.log('cc',this.goods_cat_list[i].son[k])
							if(!this.goods_cat_list[i].son[k].son){
								this.goods_cat_list[i].son[k].son = [
									{
									    id: 0,
									    name: this.$t('m.MallCenter_20'),
									 	Selected:true,
									}
								]
							}else{
								this.goods_cat_list[i].son[k].son.unshift({
								    id: 0,
								    name: this.$t('m.MallCenter_20'),
								 	Selected:true,
								})
							}
							
						}
					}
					console.log('goods_cat_list',that.goods_cat_list)
                }
            })
        },
        //商品品牌
        get_brand() {
            this.$api.get_brand().then((res) => {
                if (res.data.code == 1) {
                    this.goods_brand_list = res.data.data || []
                    this.goods_brand_list.unshift({
                        id: 0,
                        name: this.$t('m.MallCenter_20')
                    })
                    this.goods_brand_list.forEach(item => {
                        this.$set(item, 'Selected', false)



                        if (item.id == this.brand_id) {
                            item.Selected = true
                        }


                    })
                }
            })
        },
		// 搜索提交
        confirm() {
            // if (!this.value) {
            //     this.$message.warning(this.$t('m.MallCenter_21'));
            // } else if (!this.user_data) {
            //     this.$message.warning(this.$t('m.MallCenter_22'));
            //     setTimeout(() => {
            //         this.$router.push({
            //             path: '/account/login'
            //         })
            //     }, 1000);
            // } else {
                this.getData()
            // }
        },
		// 立即下单
        PlaceOrder() {
            if (!this.user_data) {
                this.$message.warning(this.$t('m.MallCenter_22'));
				setTimeout(()=>{
					this.$router.push({
					    path: '/account/login'
					})
				},2000)
                return
            }
			
			var goods_arr = []
			for (var i in this.goods_arr_history) {
				for (var k in this.goods_arr_history[i]) {
					goods_arr.push(this.goods_arr_history[i][k])
				}
			}
			console.log(this.goods_arr_history)
			// console.log(goods_arr)
			
			
            if (!goods_arr.length) {
                this.$message.warning(this.$t('m.MallCenter_23'));
                return
            }
            let param = {
                user_id: JSON.parse(localStorage.getItem('user_data')).id || '',
                goods_arr: JSON.stringify(goods_arr)
            }
            let sing = encryption.getSing(param)
            this.$api.order_check(param, sing).then((res) => {
                if (res.data.code == 1) {
                    this.$router.push({
                        path: '/PlaceOrder?goods_arr=' + JSON.stringify(goods_arr)
                    })
                }
            })

        },
		
		
		
		
		
		//分页
		handleCurrentChange(val) {
		
		    // this.current_page = val
		    // this.getData()
			
			
			// for (var i in this.tableData) {
			// 	this.tableData[i].isopen = false
			// }
			// this.expands = [];
			// console.log(this.tableData)
			
			// this.goods_arr_history[this.current_page*1-1] = this.goods_arr
			this.tableData_history[this.current_page * 1 - 1] = this.tableData
			// console.log(this.goods_arr_history)
			
			
			this.showbox = false
			if (this.goods_arr_history[val * 1 - 1]) {
				// console.log('之前有列表数据,page',val*1-1)
				// console.log(this.tableData_history)
				this.goods_arr = this.goods_arr_history[val * 1 - 1]
				this.tableData = this.tableData_history[val * 1 - 1]
				this.current_page = val
			} else {
				// console.log('之前没列表数据')
				this.goods_arr = []
				this.current_page = val
				this.getData()
			}
			
		},
		// 选择规格
        changradio(item, index) {
            let list = this.tableData.filter(item1 => {
                return item1.id == item.id
            })
            if (Object.values(list[0].goods_spec_price)[index].store_count < 1) {
                this.$message.warning(this.$t('m.MallCenter_24'));
                return
            }
            //下单列表删除数据
            if (Object.values(list[0].goods_spec_price)[index].Selected == true) {
                Object.values(list[0].goods_spec_price)[index].Selected = false
                let spec_key = Object.values(list[0].goods_spec_price)[index].spec_key
                let goods_id = item.id

                for (let index = 0; index < this.goods_arr.length; index++) {
                    if (this.goods_arr[index].goods_id == goods_id && this.goods_arr[index].spec_key == spec_key) {
                        this.goods_arr.splice(index, 1)
                    }
                }
            } else {
               //下单列表添加数据
                Object.values(list[0].goods_spec_price)[index].Selected = true
                this.goods_arr.push({
                    goods_id: item.id,
                    spec_key: Object.values(list[0].goods_spec_price)[index].spec_key,
                    goods_num: Object.values(list[0].goods_spec_price)[index].num
                })
            }
			this.goods_arr_history[this.current_page * 1 - 1] = this.goods_arr
			var key_name = ''
			for(var i in item.goods_spec){
				key_name = i
			}
			
			if(item.goods_spec_price[index].num==0){
				this.add2(index,item)
			}
        },
		// 选择规格
		changradio2(item, index) {
		    let list = this.tableData.filter(item1 => {
		        return item1.id == item.id
		    })
		    if (Object.values(list[0].goods_spec_price)[index].store_count < 1) {
		        this.$message.warning(this.$t('m.MallCenter_24'));
		        return
		    }
		    //下单列表删除数据
		    if (Object.values(list[0].goods_spec_price)[index].Selected == true) {
		        Object.values(list[0].goods_spec_price)[index].Selected = false
		        let spec_key = Object.values(list[0].goods_spec_price)[index].spec_key
		        let goods_id = item.id
		
		        for (let index = 0; index < this.goods_arr.length; index++) {
		            if (this.goods_arr[index].goods_id == goods_id && this.goods_arr[index].spec_key == spec_key) {
		                this.goods_arr.splice(index, 1)
		            }
		        }
		    } else {
		        //下单列表添加数据
		        Object.values(list[0].goods_spec_price)[index].Selected = true
		        this.goods_arr.push({
		            goods_id: item.id,
		            spec_key: Object.values(list[0].goods_spec_price)[index].spec_key,
		            goods_num: Object.values(list[0].goods_spec_price)[index].num
		        })
		    }
		    // console.log(this.goods_arr)
			this.goods_arr_history[this.current_page * 1 - 1] = this.goods_arr
			
			
			// console.log(item)
			// console.log(item.goods_spec['规格项'])
			
			
			// if(item.goods_spec_price[item.goods_spec['规格项'][index].spec_item_id*1].num==0){
			// 	this.add2(index,item)
			// }
			
			
			
		},
		//递减
		reduce(index, row) {
		    let goods_id = row.id
			var nub = 0
		    this.tableData.forEach(item => {
		        if (item.id == goods_id) {
		            // console.log(Object.values(item.goods_spec_price)[index])
		            if (Object.values(item.goods_spec_price)[index].num > 0) {
		                Object.values(item.goods_spec_price)[index].num--
						nub = Object.values(item.goods_spec_price)[index].num
		            }else{
						nub = 1
					}
		            //判断如果已经添加到下单列表
		            if (Object.values(item.goods_spec_price)[index].Selected == true) {
		                this.goods_arr.forEach(item1 => {
		                    // console.log('下单列表', item1)
		                    if (item1.spec_key == Object.values(item.goods_spec_price)[index].spec_key && goods_id == item1.goods_id) {
		                        //更新下单列表商品数量
		                        item1.goods_num = Object.values(item.goods_spec_price)[index].num
		                    }
		                })
		            }
		        }
		    })
			
			
			if(nub == 0){
				this.changradio2(row,index)
			}
		},
		//递增
		add(index, row) {
		    let goods_id = row.id
			var nub = 0
		    this.tableData.forEach(item => {
		        if (item.id == goods_id) {
		            // console.log(Object.values(item.goods_spec_price)[index])
		            Object.values(item.goods_spec_price)[index].num++
					nub = Object.values(item.goods_spec_price)[index].num
		            //判断如果已经添加到下单列表
		            if (Object.values(item.goods_spec_price)[index].Selected == true) {
		                this.goods_arr.forEach(item1 => {
		                    // console.log('下单列表', item1)
		                    if (item1.spec_key == Object.values(item.goods_spec_price)[index].spec_key && goods_id == item1.goods_id) {
		                        //更新下单列表商品数量
		                        item1.goods_num = Object.values(item.goods_spec_price)[index].num
		                    }
		                })
		            }
		        }
		    })
			
			// console.log(1)
			if(nub == 1){
				this.changradio2(row,index)
			}
			
		},
		//递增
		add2(index, row) {
		    let goods_id = row.id
			var nub = 0
		    this.tableData.forEach(item => {
		        if (item.id == goods_id) {
		            // console.log(Object.values(item.goods_spec_price)[index])
		            Object.values(item.goods_spec_price)[index].num++
					nub = Object.values(item.goods_spec_price)[index].num
		            //判断如果已经添加到下单列表
		            if (Object.values(item.goods_spec_price)[index].Selected == true) {
		                this.goods_arr.forEach(item1 => {
		                    // console.log('下单列表', item1)
		                    if (item1.spec_key == Object.values(item.goods_spec_price)[index].spec_key && goods_id == item1.goods_id) {
		                        //更新下单列表商品数量
		                        item1.goods_num = Object.values(item.goods_spec_price)[index].num
		                    }
		                })
		            }
		        }
		    })
			
			// console.log(1)
			// if(nub == 1){
			// 	this.changradio(row,index)
			// }
			
		},
        login() {
            this.$router.push({
                path: '/account/login'
            })
        }
    }
}
</script>
<style lang="scss" scoped>
	// 修改部分
	.banner{
		margin-top: 20px;
		width: 27rem;
	}

// 修改部分
.main_box {
    margin-top: 15px;
    background-color: #fff;
    padding: 35px 17.5% 70px 17.5%;
    min-width: 100%;
    // min-width: 1500px;
}

.el-form--inline .el-form-item {
    width: 100%;

}

::v-deep .el-form--inline .el-form-item__content {
    width: 100% !important;
}



// 展开框
::v-deep .el-table__expanded-cell{
    background: rgba(233, 236, 242, 0.4);
}
::v-deep .el-form-item{
    margin-bottom: 0;
}
.commodity_info {
    width: 100%;
    display: flex;
    align-items: center;
	justify-content: flex-end;
    padding: 10px 0;
    .Selected_style {
        background-color: #ef5843 !important;
    }
	.guigename{
		width: 4.75rem;
		text-align: center;
	}
    .ridio {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 10px;
        // margin-left: 80px;
        background-color: #ecedf0;
        text-align: center;
        line-height: 20px;
        img {
            width: 12px;
            height: 9px;
        }
    }
    .text {
        width: 10.825rem;
        text-align: left;
    }
    .text1 {
        width: 6.7rem;
    }
    .InputNumber {
        display: flex;
        align-items: center;
        justify-content: center;
		width: 4.1rem;
        .btnbox {
            border-radius: 3px;
            border: 2px solid #e5e5e5;
            width: 40px;
            height: 24px;
            line-height: 24px;
            font-weight: bold;
        }
        .inpunumber {
            ::v-deep .el-input__inner {
                border: 0 !important;
                padding: 0 !important;
                width: 30px;
                text-align: center;
				background: none;
            }
        }
    }
}


.user_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-left: 5px solid #ef5843;
    height: 26px;
    padding-right: 30px;
    .user_box_left {
        padding-left: 25px;
    }
}

.search {
    width: 100%;
    padding: 0 30px;
    ::v-deep .el-input__prefix {
        display: flex;
        margin-left: 20px;
    }
    ::v-deep .el-input__inner {

        padding-left: 70px !important;
        font-size: 16px;
    }
    .inpunt_box {
        width: 100%;
        border: 2px solid #ef5843;
        background-color: #ef5843;
        border-radius: 3px;
        .header-icon {
            margin-right: 4px;
            width: 24px !important;
            height: 24px !important;
        }
        ::v-deep .el-input__inner {
            border: 0 !important;
            border-radius: 0;
            height: 74px;
            background-color: #f6f7fa;
        }
        ::v-deep .el-input-group__append {
            color: #fff;
            background-color: #ef5843;
            cursor: pointer;
            border: 0 !important;
            width: 100px;
            font-size: 16px;
            font-weight: bold;
            text-align: center;
        }
        .search_btn {
            color: #fff;
            font-size: 15px;
        }
    }
}

.breadcrumb {
    padding: 35px 30px 20px 30px;

}

.classification {
    margin-top: 12px;
    display: flex;
    padding: 0 30px;
    font-size: 16px;
    display: flex;
	margin-top: 20px;
    .Selected_style {
        color: #ef5843 !important;
    }

    .title {
        white-space: nowrap;
        width: 80px;
        margin-top: 8px;

    }
	.jt{
		margin-top: 16px;
		img{
			width: 20px;height: 20px;
			transition: 0.3s;
		}
	}
    .item-box {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        // margin-top: 8px;
		height: 60px;
		overflow: hidden;
		transition: 0.3s;
		// padding-left: 30px;
		.item {
			// margin-left: 30px;
			// min-width: 100px;
			padding: 0 15px;
			text-align: center;
			white-space: nowrap;
			margin-top: 8px;
		}
    }


}

.tableDatabox {
    padding: 0 30px;
    margin-top: 30px;
}

.pagingbox {
    padding: 0 30px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    ::v-deep .el-button {
        background-color: #ef5843;
        width: 185px;
        height: 54px;
        font-weight: bold !important;
    }
}

::v-deep.el-table th.el-table__cell {
    background-color: #e9ecf2;
    color: #000000;
}

.el-table ::v-deep.el-table__cell {
    text-align: center;
}

::v-deep .el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: 0 !important;
}

.usertext {
    text-align: center;
    margin-top: 30px;
    font-size: 14px;
    color: #373d50;

    span {
        color: #ef5843;
    }
}

.red_style {
    color: #ef5843;
}

::v-deep .el-image__inner {
    border-radius: 5px;
}

::v-deep .el-breadcrumb__inner {
    font-weight: bold !important;
    color: #3b404d !important;
}

::v-deep .is-link {
    color: #a5a9b4 !important;
    font-weight: 400 !important;
}

.showbox {
    width: 100%;


    .showbox_02 {
        height: 70vh;

        overflow: auto;
        display: flex;

        .show_main {
            flex: 1;
        }

        .show_left {
            width: 10px;

        }

        .show_right {
            width: 10px;

        }
    }



    p {
        margin-top: 20px;

        span {
            color: #0f67fc;
        }
    }

    div {
        // margin-top: 20px;
    }

    .info_title {
        font-weight: bold;
        font-size: 16px;
    }

    .info_box {
        // line-height: 160%;
        color: #565a65;

        div {
            margin-top: 20px;
            letter-spacing: 1px;
        }
    }
}

::v-deep .el-dialog--center {
    border-radius: 15px;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: #2e3341;
    font-size: 24px;
    font-weight: bold;
}

::v-deep .el-dialog__header {
    padding: 0 !important;
}

::v-deep .el-dialog {
    margin-top: 5vh !important;
}

::v-deep .el-dialog__body {
    height: 90vh;
    padding: 30px !important;

}




/deep/ .el-table__expand-icon {
    visibility: hidden;
}

.pointerbox {
    display: flex;
    align-items: center;
    justify-content: center;
	i{
		margin-left: 4px;margin-top: 2px;
		transition: 0.3s;
		
	}
}
.tableDatabox_h5{display: none;}


// 宽度小于1200px
@media screen and (max-width: 1200px){
	.banner{
		margin-top: 20px;
		width: 16.2rem;
	}
	.main_box{
		padding: 0.6rem;
		padding-bottom: 7rem;
		.search{
			padding: 0;
			.inpunt_box{
				::v-deep .el-input__inner {
				    border: 0 !important;
				    border-radius: 0;
				    height: 2.05rem;
					padding-left: 1rem!important;
					font-size:0.6rem!important;
				    background-color: #f6f7fa;
				}
				::v-deep .el-input__prefix{
					display: none;
				}
				::v-deep .el-input-group__append{
					.search_btn{
						font-size: 0.65rem;
					}
				}
			}
		}
		.breadcrumb{
			padding: 1rem 0;
			padding-bottom: 0.5rem;
		}
		.classification{
			margin-top: 0.6rem;
			padding: 0;
			align-items: flex-start;
			font-size: 0.7rem;
			.title{
				width: 2.8rem;
			}
			.jt{
				display: flex;
				justify-content: center;
				align-items: center;
				margin-left: 0.3rem;
				margin-right: 0.2rem;
				margin-top: 0.55rem;
				img{
					display: block;
					width: 0.7rem;
					height: 0.7rem;
				}
			}
			.item-box{
				white-space: normal;
				height: 1.5rem!important;
				width: calc(100% - 4rem);
				overflow: hidden;
				transition: 0.3s;
				height: auto;
				.item{
					position: relative;
					height: 1rem;
					margin-top: 0.4rem;
					&::after{
						content: '';
						width: 0%;
						height: 0.1rem;
						background: rgba(239, 88, 67, 0.9);
						left: 50%;
						bottom: 0rem;
						transform: translateX(-50%);
						position: absolute;
						transition: 0.3s;
					}
				}
				.Selected_style{
					&::after{
						width: 85%;
						transition: 0.3s;
					}
				}
			}
		}
		.tableDatabox{
			padding: 0;
			display: none;
		}
		.tableDatabox_h5{
			display: block;
			transform: translateY(-1rem);
			.other_box{
				// margin-top: 20px;
				background: #fff;
				margin: auto;
				margin-top: 0.875rem;
				padding-top: 0;
				height: auto;
				.tit{
					font-size: 0.9rem;
					font-weight: 600;
					padding: 0.6rem 0rem;
					border-bottom: 0.025rem solid #dddddd;
				} 
				.status{
					margin-top: 0.5rem;
					p{
						font-size: 0.55rem;
						font-weight: 600;
						color: #ef5843;
					}
				}
				.item_o{
					border-radius: 0.2rem;
					min-height: 5.825rem;
					background: #fff;
					margin: auto;
					padding-top: 0.075rem;
					padding-bottom: 1rem;
					.tips{
						padding-top: 0.9rem;
						padding-bottom: 0.2rem;
						font-size: 0.3rem;
						font-weight: 600;
						&:last-child{
							padding-top: 0.2rem;
						}
						input{
							width: 85%;
							text-align: right;
							font-size: 0.6rem;
							&::placeholder{
								color: #b9babb;
							}
						}
					}
					.goods{
						margin-top: 0.5rem;
						.l{
							width: 4.175rem;
							height: 3.95rem;
							margin-right: 0.6rem;
							img{
								width: 4.175rem;
								height: 3.95rem;
								border-radius: 0.2rem;
							}
						}
						.r{
							width: calc(100% - 3.775rem);
							.tbox1{
								p{
									font-size: 0.70rem;
									font-weight: 600;
								}
							}
							.tbox2{
								margin-top: 0.4rem;
								p{
									font-size: 0.6rem;
									color: #7d7d89;
								}
							}
						}
					}
				}
				.item{
					margin-bottom: 0.275rem;
					p{
						font-size: 0.6rem;
						&:first-child{
							width: 35%;
							font-size: 0.6rem;
							font-weight: 600;
						}
						&:last-child{
							width: 65%;
							text-align: right;
						}
					}
				}
				.ggboxc{
					background: rgba(233, 236, 242, 0.4);
					padding:  0.6rem 0.5rem;
					margin-top: 1rem;
					border-radius: 0.2rem;
					height: 3.2rem;
					overflow: hidden;
					transition: 0.3s;
					.tit2{
						font-size: 0.8rem;
						font-weight: 600;
						padding: 0.4rem 0rem;
						img{
							width: 0.8rem;
							height: 0.8rem;
							transform: rotate(0deg);
							transition: 0.3s;
						}
					} 
					.gg_box{
						padding: 0.2rem 0;
						.item_gg1{
							padding: 0.3rem 0;
							font-size: 0.6rem;
							text-align: center;
							div{
								display: flex;
								align-items: center;
								justify-content: center;
								border-radius: 50%;
								width: 1rem;
								height: 1rem;
								background: #ecedf0;
								margin-right: 1rem;
								img{
									width: 0.5rem;
									height: 0.5rem;
								}
							}
							.active{
								background: #ef5843;
							}
						}
						.item_gg2{
							padding: 0.3rem 0;
							div{
								display: flex;
								align-items: center;
								justify-content: center;
								.btnbox {
								    border-radius: 3px;
								    border: 2px solid #e5e5e5;
								    width: 40px;
								    height: 24px;
								    line-height: 24px;
								    font-weight: bold;
								}
								.inpunumber {
								    ::v-deep .el-input__inner {
								        border: 0 !important;
								        padding: 0 !important;
								        width: 30px;
								        text-align: center;
										background: none;
								    }
								}
							}
							p{
								font-size: 0.6rem;
								text-align: center;
								width: calc(100%/3);
							}
						}
					}
				}

			}
		}
		.pagingbox{
			justify-content: center;
			padding: 0!important;
			.pages_pc{
				width: 100%;
				display: none;
			}
			.pagea{
				width: 100%;
				display: none;
			}
		}
		._btn{
			position: fixed;
			left: 50%;
			transform: translateX(-50%);
			bottom: 2.5rem;
		}
	}
}
.firstcat{
	.title{
		width: 50px;
	}
	.item-box{
		align-items: flex-start;
		justify-content: flex-start;
		height: auto!important;
		// width: calc(100% - 60px);
		.item{
			// margin-top: 0;
		}
	}
}
</style>